export default "__VITE_ASSET__tKCSriLG__"